import {
  ChangeDetectionStrategy, Component, computed, EventEmitter, Input, input, Output, output, signal, ViewEncapsulation
} from '@angular/core';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { TranslateModule } from '@ngx-translate/core';

import {
  BrandsEnum, DeviceService, SdButtonComponent, SdButtonIconComponent, SdFormCheckboxComponent,
  SdLibConfig, SdSkeletonComponent, SkeletonAppearanceEnum
} from '@seb/web-design-system/core';

@Component({
  selector: 'sd-product-actions',
  templateUrl: './product-actions.component.html',
  styleUrls: ['./product-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: true,
  imports: [
    SdFormCheckboxComponent,
    SdButtonComponent,
    SdButtonIconComponent,
    SdSkeletonComponent,
    TranslateModule
  ],
  host: {
    '[class.is-small]': 'isSmall()'
  }
})
export class SdProductActionsComponent {
  brand = input<BrandsEnum>();
  isLoading = input(false);
  horizontalParentLayout = input(false);
  isInFavorite = input(false);
  isInStock = input<boolean>();
  onSale = input(true);
  hasPrice = input(true);
  isProductComparator = input<boolean>();
  url = input<string>();
  productName = input<string>();
  isSmall = input(false);

  favorite = output<boolean>();
  cart = output<boolean>();
  notify = output<boolean>();

  @Input()
  isCompared: boolean;

  @Output()
  isComparedChange = new EventEmitter<boolean>();

  SkeletonAppearanceEnum = SkeletonAppearanceEnum;
  isMobile = signal(false);
  showWishList: boolean;

  favoriteIcon = computed(() => this.isInFavorite() ? 'icon-heart-filled' : 'icon-heart');

  constructor(
    sdLibConfig: SdLibConfig,
    deviceService: DeviceService
  ) {
    this.showWishList = sdLibConfig.get().wishList;

    deviceService.isMobile.pipe(takeUntilDestroyed()).subscribe((x) => {
      this.isMobile.set(x);
    });
  }

  addToFavorite() {
    return this.favorite.emit(!this.isInFavorite());
  }

  addToComparator(event: boolean) {
    this.isComparedChange.emit(event);
  }

  addToCart() {
    return this.cart.emit(true);
  }

  stockNotify() {
    return this.notify.emit(true);
  }
}
